<table mat-table [dataSource]="feedbackDataSource">

	<ng-container matColumnDef="id">
		<th mat-header-cell *matHeaderCellDef>Feedback</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.id}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="appointmentId">
		<th mat-header-cell *matHeaderCellDef>Appt Id</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.appointmentId}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="message">
		<th mat-header-cell *matHeaderCellDef>Message</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.message}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="timestamp">
		<th mat-header-cell *matHeaderCellDef>Timestamp</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.timestamp | orgDate: 'MM/dd/yyyy: HH:mm' }}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="type">
		<th mat-header-cell *matHeaderCellDef>Type</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.type}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="organizationId">
		<th mat-header-cell *matHeaderCellDef>Org Id</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.organizationId}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="url">
		<th mat-header-cell *matHeaderCellDef>Url</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.url}}</div>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goto(row)">

</table>
